var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconstyleImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.885 7.35498H12.5C12.3674 7.35498 12.2402 7.40766 12.1464 7.50143C12.0527 7.5952 12 7.72237 12 7.85498C12 7.98759 12.0527 8.11477 12.1464 8.20853C12.2402 8.3023 12.3674 8.35498 12.5 8.35498H13.87C14.0026 8.35498 14.1298 8.3023 14.2236 8.20853C14.3173 8.11477 14.37 7.98759 14.37 7.85498C14.37 7.72237 14.3173 7.5952 14.2236 7.50143C14.1298 7.40766 14.0026 7.35498 13.87 7.35498H13.885Z",
    fill: "url(#paint0_linear_2409_34668)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.885 10.355H12.5C12.3674 10.355 12.2402 10.4077 12.1464 10.5014C12.0527 10.5952 12 10.7224 12 10.855C12 10.9876 12.0527 11.1148 12.1464 11.2085C12.2402 11.3023 12.3674 11.355 12.5 11.355H13.885C14.0176 11.355 14.1448 11.3023 14.2386 11.2085C14.3323 11.1148 14.385 10.9876 14.385 10.855C14.385 10.7224 14.3323 10.5952 14.2386 10.5014C14.1448 10.4077 14.0176 10.355 13.885 10.355Z",
    fill: "url(#paint1_linear_2409_34668)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8867 13.355H1.88672C1.75411 13.355 1.62693 13.4077 1.53317 13.5014C1.4394 13.5952 1.38672 13.7224 1.38672 13.855C1.38672 13.9876 1.4394 14.1148 1.53317 14.2085C1.62693 14.3023 1.75411 14.355 1.88672 14.355H13.8867C14.0193 14.355 14.1465 14.3023 14.2403 14.2085C14.334 14.1148 14.3867 13.9876 14.3867 13.855C14.3867 13.7224 14.334 13.5952 14.2403 13.5014C14.1465 13.4077 14.0193 13.355 13.8867 13.355Z",
    fill: "url(#paint2_linear_2409_34668)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.885 4.35498H12.5C12.3674 4.35498 12.2402 4.40766 12.1464 4.50143C12.0527 4.5952 12 4.72237 12 4.85498C12 4.98759 12.0527 5.11477 12.1464 5.20853C12.2402 5.3023 12.3674 5.35498 12.5 5.35498H13.87C14.0026 5.35498 14.1298 5.3023 14.2236 5.20853C14.3173 5.11477 14.37 4.98759 14.37 4.85498C14.37 4.72237 14.3173 4.5952 14.2236 4.50143C14.1298 4.40766 14.0026 4.35498 13.87 4.35498H13.885Z",
    fill: "url(#paint3_linear_2409_34668)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.35498H2C1.86739 7.35498 1.74021 7.40766 1.64645 7.50143C1.55268 7.5952 1.5 7.72237 1.5 7.85498C1.5 7.98759 1.55268 8.11477 1.64645 8.20853C1.74021 8.3023 1.86739 8.35498 2 8.35498H3.5C3.63261 8.35498 3.75979 8.3023 3.85355 8.20853C3.94732 8.11477 4 7.98759 4 7.85498C4 7.72237 3.94732 7.5952 3.85355 7.50143C3.75979 7.40766 3.63261 7.35498 3.5 7.35498Z",
    fill: "url(#paint4_linear_2409_34668)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.355H3.5C3.63261 11.355 3.75979 11.3023 3.85355 11.2085C3.94732 11.1148 4 10.9876 4 10.855C4 10.7224 3.94732 10.5952 3.85355 10.5014C3.75979 10.4077 3.63261 10.355 3.5 10.355H2C1.86739 10.355 1.74021 10.4077 1.64645 10.5014C1.55268 10.5952 1.5 10.7224 1.5 10.855C1.5 10.9876 1.55268 11.1148 1.64645 11.2085C1.74021 11.3023 1.86739 11.355 2 11.355Z",
    fill: "url(#paint5_linear_2409_34668)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.35498H2C1.86739 4.35498 1.74021 4.40766 1.64645 4.50143C1.55268 4.5952 1.5 4.72237 1.5 4.85498C1.5 4.98759 1.55268 5.11477 1.64645 5.20853C1.74021 5.3023 1.86739 5.35498 2 5.35498H3.5C3.63261 5.35498 3.75979 5.3023 3.85355 5.20853C3.94732 5.11477 4 4.98759 4 4.85498C4 4.72237 3.94732 4.5952 3.85355 4.50143C3.75979 4.40766 3.63261 4.35498 3.5 4.35498Z",
    fill: "url(#paint6_linear_2409_34668)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.35498H13.885C14.0176 2.35498 14.1448 2.3023 14.2386 2.20853C14.3323 2.11477 14.385 1.98759 14.385 1.85498C14.385 1.72237 14.3323 1.5952 14.2386 1.50143C14.1448 1.40766 14.0176 1.35498 13.885 1.35498H2C1.86739 1.35498 1.74021 1.40766 1.64645 1.50143C1.55268 1.5952 1.5 1.72237 1.5 1.85498C1.5 1.98759 1.55268 2.11477 1.64645 2.20853C1.74021 2.3023 1.86739 2.35498 2 2.35498Z",
    fill: "url(#paint7_linear_2409_34668)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.5C6.10218 4.5 5.72064 4.65804 5.43934 4.93934C5.15804 5.22064 5 5.60218 5 6V10C5 10.3978 5.15804 10.7794 5.43934 11.0607C5.72064 11.342 6.10218 11.5 6.5 11.5H9.5C9.89782 11.5 10.2794 11.342 10.5607 11.0607C10.842 10.7794 11 10.3978 11 10V6C11 5.60218 10.842 5.22064 10.5607 4.93934C10.2794 4.65804 9.89782 4.5 9.5 4.5H6.5ZM10 6V10C10 10.1326 9.94732 10.2598 9.85355 10.3536C9.75979 10.4473 9.63261 10.5 9.5 10.5H6.5C6.36739 10.5 6.24021 10.4473 6.14645 10.3536C6.05268 10.2598 6 10.1326 6 10V6C6 5.86739 6.05268 5.74021 6.14645 5.64645C6.24021 5.55268 6.36739 5.5 6.5 5.5H9.5C9.63261 5.5 9.75979 5.55268 9.85355 5.64645C9.94732 5.74021 10 5.86739 10 6Z",
    fill: "url(#paint8_linear_2409_34668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2409_34668",
    x1: 14.3776,
    y1: 8.64937,
    x2: 12.3577,
    y2: 6.97815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2409_34668",
    x1: 14.3927,
    y1: 11.6494,
    x2: 12.3704,
    y2: 9.96562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2409_34668",
    x1: 14.4285,
    y1: 14.6494,
    x2: 13.5643,
    y2: 10.7272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2409_34668",
    x1: 14.3776,
    y1: 5.64937,
    x2: 12.3577,
    y2: 3.97815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2409_34668",
    x1: 4.00804,
    y1: 8.64937,
    x2: 1.97062,
    y2: 6.87122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2409_34668",
    x1: 4.00804,
    y1: 11.6494,
    x2: 1.97061,
    y2: 9.87122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2409_34668",
    x1: 4.00804,
    y1: 5.64937,
    x2: 1.97061,
    y2: 3.87122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2409_34668",
    x1: 14.4264,
    y1: 2.64937,
    x2: 13.5552,
    y2: -1.26959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2409_34668",
    x1: 11.0193,
    y1: 13.5608,
    x2: 3.1129,
    y2: 11.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstyleImage);
export default __webpack_public_path__ + "static/media/iconstyle-image.46b3257cc6dfeb1f5353305ef8ca5ac0.svg";
export { ForwardRef as ReactComponent };